/**
 * Extracts a script URL from either a bare URL or a full `<script>` tag snippet.
 */
export function parseScriptSrc(input: string): string | null {
  const trimmed = input.trim();
  if (!trimmed) {
    return null;
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  const srcMatch = trimmed.match(/src=["']([^"']+)["']/i);
  return srcMatch?.[1] ?? null;
}
